import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  AccountCircleOutlined,
  BadgeOutlined,
  CategoryOutlined,
  FilterAltOutlined,
  InfoOutlined,
  LanguageOutlined,
  MonetizationOnOutlined,
  WarehouseOutlined,
} from "@mui/icons-material";

import { useEntityDetailContext } from "contexts/EntityDetailContext";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

const EntityBasicDetail = () => {
  const { entityDetail, loadingEntity } = useEntityDetailContext();

  return !loadingEntity ? (
    <Box padding={3}>
      <Typography variant="h6">{entityDetail?.name}</Typography>

      <br />

      <Grid container spacing={4}>
        <Grid item md={4}>
          <InformationTile
            icon={() => <BadgeOutlined color="primary" />}
            title="Display Name"
            subtitle={entityDetail?.displayName}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <LanguageOutlined color="primary" />}
            title="Country"
            subtitle={entityDetail?.country?.name}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <AccountCircleOutlined color="primary" />}
            title="Account"
            subtitle={entityDetail?.account?.name}
          />
        </Grid>
        <Grid item md={4}>
          <InformationTile
            icon={() => <WarehouseOutlined color="primary" />}
            title="Warehouse"
            subtitle={entityDetail?.account?.name}
          />
        </Grid>
        <Grid item md={4}>
          <InformationTile
            icon={() => <CategoryOutlined color="primary" />}
            title="Category "
            subtitle={entityDetail?.category}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <FilterAltOutlined color="primary" />}
            title="Type "
            subtitle={entityDetail?.type}
          />
        </Grid>

        <Grid item md={4}>
          <InformationTile
            icon={() => <MonetizationOnOutlined color="primary" />}
            title="Currency "
            subtitle={entityDetail?.currency?.name}
          />
        </Grid>

        <Grid item md={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={entityDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default EntityBasicDetail;
